module.exports = __webpack_public_path__ + "static/media/unsubscribe.a8134cf0.png";